import React from 'react';
import styles from "./TermoCooperacao.css";
import Header from "../../components/features/login/Header";
import TitleModule from '../../components/features/register/TitleModule';
import RegisterProgress from '../../components/features/register/RegisterProgress';
import TermFile from '../../components/Termo/TermFile';

const PreenchaDadosPage = () => {
    return (
      <div className="PreenchaDados-Page"> 
        <Header/>
        <div className={styles.container}>
            <TitleModule/>
            <RegisterProgress step={3} title="Termo de cooperação Técnica" icon="Assignment"/>
            <TermFile/>
        </div>
      </div>
    );
  };
  
  export default PreenchaDadosPage;
  